import { createSlice } from "@reduxjs/toolkit";

const bucket = (defaultData = null) => ({ loading: false, data: defaultData, error: null });

const initialState = {
  overview: bucket(),
  kpis: bucket(),
  pickupRequests: { loading: false, data: [], error: null, meta: { total: 0, page: 1, pageSize: 25 } },
  scheduledRoutes: bucket(),
  routeMap: bucket(),
  timeline: bucket([]),
  fleetStatus: bucket(),
  materialMix: bucket(),
  filters: {
    date: new Date().toISOString().slice(0, 10),
    dateRange: "day",
    dealerGroupIds: "",
    region: "",
    keyword: "",
    selectedRouteId: null,
    statusFilter: null,
    priorityFilter: null,
    orgFilter: null,
  },
};

const commandCenterSlice = createSlice({
  name: "afmsCommandCenter",
  initialState,
  reducers: {
    // Overview
    overviewStart: (state) => { state.overview.loading = true; state.overview.error = null; },
    overviewSuccess: (state, action) => {
      state.overview.loading = false;
      state.overview.data = action.payload;
      state.kpis.data = action.payload?.kpis || null;
      state.pickupRequests.data = action.payload?.pickupRequests?.items || [];
      state.pickupRequests.meta = {
        total: action.payload?.pickupRequests?.totalCount || 0,
        page: action.payload?.pickupRequests?.pageNumber || 1,
        pageSize: action.payload?.pickupRequests?.pageSize || 25,
      };
      state.scheduledRoutes.data = action.payload?.routeSummary || null;
      state.fleetStatus.data = action.payload?.fleet || null;
      state.materialMix.data = action.payload?.materialMix || null;
    },
    overviewFailure: (state, action) => { state.overview.loading = false; state.overview.error = action.payload; },

    // KPIs
    kpisStart: (state) => { state.kpis.loading = true; state.kpis.error = null; },
    kpisSuccess: (state, action) => { state.kpis.loading = false; state.kpis.data = action.payload; },
    kpisFailure: (state, action) => { state.kpis.loading = false; state.kpis.error = action.payload; },

    // Pickup Requests
    pickupRequestsStart: (state) => { state.pickupRequests.loading = true; state.pickupRequests.error = null; },
    pickupRequestsSuccess: (state, action) => {
      state.pickupRequests.loading = false;
      state.pickupRequests.data = action.payload.items || [];
      state.pickupRequests.meta = {
        total: action.payload.totalCount || 0,
        page: action.payload.pageNumber || 1,
        pageSize: action.payload.pageSize || 25,
      };
    },
    pickupRequestsFailure: (state, action) => { state.pickupRequests.loading = false; state.pickupRequests.error = action.payload; },

    // Scheduled Routes
    scheduledRoutesStart: (state) => { state.scheduledRoutes.loading = true; state.scheduledRoutes.error = null; },
    scheduledRoutesSuccess: (state, action) => { state.scheduledRoutes.loading = false; state.scheduledRoutes.data = action.payload; },
    scheduledRoutesFailure: (state, action) => { state.scheduledRoutes.loading = false; state.scheduledRoutes.error = action.payload; },

    // Route Map
    routeMapStart: (state) => { state.routeMap.loading = true; state.routeMap.error = null; },
    routeMapSuccess: (state, action) => { state.routeMap.loading = false; state.routeMap.data = action.payload; },
    routeMapFailure: (state, action) => { state.routeMap.loading = false; state.routeMap.error = action.payload; },

    // Timeline
    timelineStart: (state) => { state.timeline.loading = true; state.timeline.error = null; },
    timelineSuccess: (state, action) => { state.timeline.loading = false; state.timeline.data = action.payload; },
    timelineFailure: (state, action) => { state.timeline.loading = false; state.timeline.error = action.payload; },

    // Fleet Status
    fleetStatusStart: (state) => { state.fleetStatus.loading = true; state.fleetStatus.error = null; },
    fleetStatusSuccess: (state, action) => { state.fleetStatus.loading = false; state.fleetStatus.data = action.payload; },
    fleetStatusFailure: (state, action) => { state.fleetStatus.loading = false; state.fleetStatus.error = action.payload; },

    // Material Mix
    materialMixStart: (state) => { state.materialMix.loading = true; state.materialMix.error = null; },
    materialMixSuccess: (state, action) => { state.materialMix.loading = false; state.materialMix.data = action.payload; },
    materialMixFailure: (state, action) => { state.materialMix.loading = false; state.materialMix.error = action.payload; },

    // Filters
    setFilters: (state, action) => { Object.assign(state.filters, action.payload); },
    resetFilters: (state) => { state.filters = initialState.filters; },
  },
});

export const {
  overviewStart, overviewSuccess, overviewFailure,
  kpisStart, kpisSuccess, kpisFailure,
  pickupRequestsStart, pickupRequestsSuccess, pickupRequestsFailure,
  scheduledRoutesStart, scheduledRoutesSuccess, scheduledRoutesFailure,
  routeMapStart, routeMapSuccess, routeMapFailure,
  timelineStart, timelineSuccess, timelineFailure,
  fleetStatusStart, fleetStatusSuccess, fleetStatusFailure,
  materialMixStart, materialMixSuccess, materialMixFailure,
  setFilters, resetFilters,
} = commandCenterSlice.actions;

export default commandCenterSlice.reducer;
